<template>
  <div class="article-placeholder--container">
    <div
      v-for="n in 5"
      :key="n"
      class="article-placeholder"
    >
      <div class="article-placeholder__separator" />
      <div class="article-placeholder__item--image">
        <LazyloadPlaceholder />
      </div>
      <div class="article-placeholder__wrapper">
        <div class="article-placeholder__item--text article-placeholder__item--title">
          <LazyloadPlaceholder />
        </div>
        <div class="article-placeholder__item--text article-placeholder__item--description">
          <LazyloadPlaceholder />
        </div>
        <div class="article-placeholder__item--text article-placeholder__item--footer">
          <LazyloadPlaceholder />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';

  export default {
    name: 'ArticleCardSmallPlaceholder',
    components: {
      LazyloadPlaceholder,
    },
  };
</script>

<style lang="scss" scoped>
  .article-placeholder {
    padding: $spacing-5 14px;
    width: 100%;
    position: relative;
    &:not(:last-child) {
      margin-bottom: $spacing-6;
    }

    @include tablet {
      display: flex;
      padding: $spacing-6;
    }

    &--container {
      background: #ffffff;
      margin-left: 2px;
      margin-right: 2px;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      width: 100%;
      margin: 0 auto;
      background: $stroke-color--1;
      height: 1px;
      @include tablet {
        width: calc(100% - 45px);
      }

      @include big-tablet {
        width: calc(100% - 65px);
      }

      @include desktop {
        width: calc(100% - 85px);
      }
    }

    &__item {
      &--image {
        width: 192px;
        height: 128px;
        border-radius: 32px;
        overflow: hidden;
        margin: 0 auto $spacing-7;

        @include tablet {
          min-width: 240px;
          min-height: 160px;
          margin-right: $spacing-6;
          margin-left: 0;
          margin-bottom: 0;
        }
      }

      &--text {
        border-radius: 12px;
        overflow: hidden;
      }

      &--title {
        height: 56px;
        width: 100%;
        margin-bottom: $spacing-2;
      }

      &--description,
      &--footer {
        height: 24px;
      }

      &--description {
        margin-bottom: $spacing-5;
      }

      &--footer {
        max-width: 205px;
      }
    }
    &__wrapper {
      flex-basis: 100%;
    }
  }
</style>
